﻿/* EFW Logon 3.0 UI plugin */
/* global require */
(function ($) {
    $.fn.logon$ui = $.fn.logon$ui || function () { };
    const _ = require('lodash'),
        async = require('./async-2014.js'),
        ID = require('./efw.id'),
        parse = require('url-parse');

    const _block = function (cls) {
        return $('<div></div>').addClass(cls);
    }, _link = function (cls, href, text) {
        return $('<a></a>').addClass(cls).text(text).attr('href', href);
    }, _linkButton = function (cls, href, text) {
        return $('<a></a>').addClass(cls).attr('href', href).attr('role', 'button').append($('<span></span>').text(text).addClass('text'));
    }, _virtualDoc = function () {
        // Create a virtual document to use when parsing the data, so we don't load the images etc.
        return document.implementation.createHTMLDocument('virtual');
    };

    // Embed dialogs
    $.fn.logon$embedDialogs = function (options) {
        var opts = $.extend({}, $.fn.logon$ui.defaults, options);

        $.get(
            (opts.uiService || '') + '/_hub3/logon.htm'
        ).done(_.bind(function (data /* textStatus, jqXHR */) {
            // ensure jquery "this" is context at the callback function
            var $data = $(data, _virtualDoc());
            console.log('logon$embedDialogs: done');
            var ret = this.each(function () {
                var $this = $(this),
                    $container = _block('bootstrap dialogs');
                $container.append($data.find('.logarea-dialogs'));
                $container.find('.modal').addClass('bootstrap');
                $this.append($container);
            });
            if (options.callback)
                options.callback();
            return ret;
        }, this)).fail(function (jqXHR, textStatus/*, errThrown*/) {
            console.log('logon$embedLogarea: fail: ' + textStatus);
            if (options.callback)
                options.callback(textStatus);
        });
    };

    // Embed logon area here. Check options.mobile boolean for mobile variant.
    $.fn.logon$embedLogarea = function (options) {
        var opts = $.extend({}, $.fn.logon$ui.defaults, options);

        var ret = this.each(function () {
            $(this).addClass('logarea bootstrap');    // for global subscriptions.
            if (opts.mobile)
                $(this).addClass('mobile');

            let loggedIn = _block('loggedIn').css('display', 'none');
            let loggedOut = _block('loggedOut').css('display', 'none');

            // logged out interface is a link-button.
            loggedOut.append(_linkButton('logon-button', '#logon', opts.mobile ? 'Sign in: My Vault' : 'Sign in to My Vault')); // TODO: manage text

            // logged in interface
            let buttonId = ID();
            
            if (opts.mobile) {
                // mobile version.
                let controller = _linkButton('logon-controller logon-button', 'javascript:void(0);', 'My Vault').attr('id', buttonId);
                // ...it's a collapse controller
                let collapseId = ID();

                controller.addClass('collapse-trigger').attr('data-toggle', 'collapse').attr('href', '#' + collapseId).attr('aria-expanded', 'false').attr('aria-controls', collapseId);

                // ...contents
                let contents = _block('collapse collapse-contents').attr('id', collapseId);

                // ...login name text; divider
                contents.append(_block('item').attr('name', 'logname'));
                contents.append(_block('item divider'));
                contents.append(_link('item', '/my.htm', 'My Vault dashboard')); // TODO: manage text
                contents.append(_link('item', '#profile', 'Update profile'));  // TODO: manage text
                contents.append(_link('item', 'javascript:void(0);', 'Log out').attr('name', 'logout'));    // TODO: manage text

                // ...profile link

                loggedIn.append(controller, contents);
            } else {
                let group = _block('logon-group');

                // desktop version.
                // ...it's a popover controller
                let controller = _linkButton('logon-controller logon-button', 'javascript:void(0);', '').attr('id', buttonId);
                controller.addClass('popover-trigger').attr('data-toggle', 'popover').attr('data-placement', 'bottom');
                controller.find('.text').attr('name', 'logname');   // fillin logged-in name

                // ... contents
                let hidden = _block('hidden').css('display', 'none'),
                    contents = _block('contents'),
                    close = $('<a href="javascript:void(0);" class="close"><span class="sr-only">Close</span>&times;</a>'); // TODO: manage text
                // ...profile link
                contents.append(_link('item', '#profile', 'Update profile'));  // TODO: manage text
                let vaultLink = _link('vault-link item', '/my.htm', 'My Vault'); // TODO: manage text
                let logoutLink = _link('logout-link item', 'javascript:void(0);', 'Log out').attr('name', 'logout');

                // ...assemble.
                hidden.append(contents);
                group.append(controller, hidden, vaultLink, logoutLink);

                loggedIn.append(group);

                // activate the popover
                close.on('click', function () {
                    $('#' + buttonId).popover('hide');
                });
                controller.popover({ content: contents, title: close, html: true, trigger: 'click' });
            }

            $(this).append(loggedIn, loggedOut);
            console.log('logarea assembled');
        });

        if (opts.callback) {
            opts.callback();
        }

        return ret;
    };

    $.fn.logon$embedFavoriteUI = function (options) {
        var opts = $.extend({}, $.fn.logon$ui.defaults, options);

        var stuff = this.each(function () {
            var $this = $(this);
            $this.append('<div class="favoriteUI-wrapper bootstrap"><div class="loggedOut" style="display:none;"><a class="dlgPop saveFavoriteIntent" intent="logon.intent.savefavorites" href="#logon">Add to favorites</a></div><div class="favoriteUI loggedIn" rel-type="page"><a class="add" href="javascript:void(0);" style="display:none;">Add to favorites</a><span class="remove" style="display: none">One of my favorites</span></div></div>');
        });

        // no async here
        if (opts.callback) {
            opts.callback();
        }
        return stuff;
    };

    // Embed Vault Dashboard
    $.fn.logon$embedVaultDashboard = function (options) {
        var opts = $.extend({}, $.fn.logon$ui.defaults, options);

        $.get(
            (opts.uiService || '') + '/_hub3/my.htm'
        ).done(_.bind(function (data /* textStatus, jqXHR */) {
            // ensure jquery "this" is context at the callback function
            var $data = $(data, _virtualDoc());
            console.log('logon$embedVaultDashboard: done');
            var ret = this.each(function () {
                var $this = $(this),
                    $container = _block('bootstrap my-vault'),
                    $content = $data.find('.slot_content');

                // fix up links to DB101/HB101 favorites
                var $favLinks = $content.find('.favorites-other-sites');
                // defined in efw.logon.3.0.services.js
                _.each(window.logon$broadcastTargets, function (v) {
                    // v.name = db101/hb101; v.url = [host]/_logshare.htm
                    var siteUri = new parse(v.url || window.location);

                    var $favLine = $favLinks.find('.' + v.name);
                    $favLine.find('a[href]').each(function () {
                        siteUri.set('pathname', $(this).attr('href'));
                        $(this).attr('href', siteUri.toString());
                    });
                });

                $container.append($content);
                $this.append($container);
            });
            if (options.callback)
                options.callback();
            return ret;
        }, this)).fail(function (jqXHR, textStatus) {
            console.log('logon$embedVaultDashboard: fail: ' + textStatus);
            if (options.callback)
                options.callback(textStatus);
        });
    };

    // Embed saved sessions
    $.fn.logon$embedSavedSessions = function (options) {
        var opts = $.extend({}, $.fn.logon$ui.defaults, options);

        $.get(
            (opts.uiService || '') + '/_hub3/my-sessions.htm'
        ).done(_.bind(function (data /* textStatus, jqXHR */) {
            // ensure jquery "this" is context at the callback function
            var $data = $(data, _virtualDoc());
            console.log('logon$embedSavedSessions: done');
            var ret = this.each(function () {
                var $this = $(this),
                    $container = _block('bootstrap my-vault'),
                    $content = $data.find('.slot_content_2');

                // remove literal images from the stream
                $content.find('img[src^="/master_images/"]').remove();

                $container.append($content);
                // fixup URLs on "Start a new session" action buttons - must use correct host, derived from sessionService
                $container.find('a.action-button, a.moreSessions').each(function () {
                    var sessionUri = new parse(opts.sessionService || window.location);
                    // .attr here. .prop decorates the URL to make it absolute.
                    sessionUri.set('pathname', $(this).attr('href'));
                    $(this).attr('href', sessionUri.toString());
                });
                // launch all in new tab.
                $container.find('a[href^=http]').attr('target', '_blank');
                $this.append($container);
            });
            if (options.callback)
                options.callback();
            return ret;
        }, this)).fail(function (jqXHR, textStatus) {
            console.log('logon$embedSavedSessions: fail: ' + textStatus);
            if (options.callback)
                options.callback(textStatus);
        });
    };

    // Embed vault here
    $.fn.logon$embedVault = function (options) {
        var opts = $.extend({}, $.fn.logon$ui.defaults, options);
        var iSlot = 1;

        var slots = this.each(function () {
            var $this = $(this);
            $this.append('<div class="loggedIn" style="display:none;"><div id="' + opts.slotId + '" class="vaultView"></div></div>');
            iSlot = iSlot + 1;
        });

        // activate the slots
        $.gevent.subscribe($('body'), 'init-efw', function () {
            $.gevent.subscribe($('#' + opts.slotId), 'efw.logon', function () {
                $('#' + opts.slotId).installVault({ service: window.logon$services.vaultService, target: $.fn.logon$getTargetView(opts.targetView), JWT: $.fn.logon$getData('access_token'), backToArticleUrl: document.referrer || '', host: window.location.host, language: opts.language, stateCode: opts.stateCode, gaClientId: opts.gaClientId, measurementId: opts.measurementId, domainBase: opts.domainBase });
            });
            $.gevent.subscribe($('#' + opts.slotId), 'efw.logout', function () {
                $('#' + opts.slotId).empty();
            });
        });

        // no async here
        if (opts.callback) {
            opts.callback();
        }
        return slots;
    };

    // default option parameters
    $.fn.logon$ui.defaults = $.extend({}, { site: -1, slotId: 'vaultProjects', targetView: '/#paths', language: 'en', stateCode: 'MN', gaClientId: 'UA-6354151-5', measurementId: 'G-1WVX9P2X0J', personalAreaPrompt: 'My Hub', vaultPage: '/my-vault', domainBase: 'hub' }, window.logon$services || {});

    $(document).ready(function () {
        // we need all of these functions to install before initializing the dialog and logon systems
        async.parallel([
            function (cb) {
                $('#hubvault_dialogs').logon$embedDialogs({ callback: cb });
            },
            function (cb) {
                $('.hubvault_loginSection').logon$embedLogarea({ callback: cb, mobile: false });
            },
            function (cb) {
                $('.hubvault_loginSectionMobile').logon$embedLogarea({ callback: cb, mobile: true });
            },
            function (cb) {
                $('#hubvault_vaultDashboardSection').logon$embedVaultDashboard({ callback: cb });
            },
            function (cb) {
                $('.hubvault_vaultSection').logon$embedVault({ callback: cb });
            },
            function (cb) {
                $('.hubvault_savedSessionsSection').logon$embedSavedSessions({ callback: cb });
            },
            function (cb) {
                $('.hubvault_favoriteSection').logon$embedFavoriteUI({ callback: cb });
            }
            //},
            //function (cb) {
            //    $('#loginSection').logon$embedLogarea({ callback: cb });
            //}
        ], function (err /*, result*/) {
            if (err) {
                console.warn('efw$logon.3.0.ui: Error: ' + err);
            } else {
                // let everything return from function call
                console.log('hub-vault: Plugins complete');
                _.defer(function () {
                    $.gevent.publish('init-efw');
                });
            }
        });

        $.gevent.subscribe($('body'), 'init-efw', function () {
            // initialize dialog and logon systems
            console.log('hub-vault initialization');
            $('.efw-dialog').efw$dialog({ injectForm: true, closePrompt: 'Close' });
            $.fn.logon$init({ site: 1000, omitImages: true, stateCode: 'MN', manageRolesFilter: ['provider', 'provider-hb', 'work-provider-mn'] });

            // bootstrapify popovers and dialogs
            $(document).on('show.bs.popover', function (e) {
                $($(e.target).data('bs.popover').tip).addClass('bootstrap');
            });
            $(document).on('show.bs.modal', function (e) {
                $('.modal').addClass('bootstrap');
            });
        });
    });
})(jQuery);